import { render, staticRenderFns } from "./OnsiteApplication.vue?vue&type=template&id=b2c504d8&scoped=true"
import script from "./OnsiteApplication.vue?vue&type=script&lang=js"
export * from "./OnsiteApplication.vue?vue&type=script&lang=js"
import style0 from "./OnsiteApplication.vue?vue&type=style&index=0&id=b2c504d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c504d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VForm } from 'vuetify/lib/components/VForm';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VDatePicker,VForm,VMenu,VRadio,VRadioGroup,VSelect,VTextField,VTextarea})
